import React, { useState } from "react";
import bem from 'utils/bem';
import { Formik } from 'formik';
import { toast } from 'react-hot-toast';
import validationSchema from './validationSchema';
import Form from './Form';
import OfficePurchasePaySuccess from './OfficePurchasePaySuccess';
import './index.sass'
import Model from '../../../../model';

const initialValues = {
    saleSum: 0,
    paymentSystem: 'A'
};

const { block } = bem('office-purchase-pay-form');

const OfficePurchasePayForm = ({pk, url, price, isDigital}) => {
    const [ submitSuccess, setSubmitSuccess ] = useState(false);

    const handleSubmit = (values) => {
        const formData = new FormData();

        formData.append('id', pk);
        formData.append('system', values.paymentSystem);
        formData.append('saleSum', values.saleSum);

        fetch(url, {
            method: 'POST',
            body: formData
        }).then((promise) => {
            return promise.json();
        }).then((response) => {
            const error = response?.error;
            if (error === 'already_paid') {
                toast.error('Заказ уже оплачен');
            } else if (error) {
                toast.error(`Произошла ошибка, пожалуйста, обратитесь к администратору: ${error}`);
            } else {
                if (response.success && response.redirect) {
                    window.location.href = response.redirect;
                } else if (response.success && response.redirect === undefined) {
                    window.location.reload();
                }
            }
        }).catch((error) => {
            toast.error(`Произошла неизвестная ошибка, обратитесь к администратору: ${error}`);
        });
    }

    if (submitSuccess) {
        return <OfficePurchasePaySuccess />
    }

    const title = `Оплата заказа №${pk}`;

    return <div className={block()}>
        <Formik
            initialValues={initialValues}
            validateOnChange={false}
            validateOnBlur={false}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            enableReinitialize={true}>
            {props => <Form {...props} price={price} title={title} isDigital={isDigital}/>}
        </Formik>
    </div>
};

export default OfficePurchasePayForm;
